<template>
  <div>
    <v-container>
      <v-card :dark="config.dark_background" :color="config.background_dark">
        <v-card-title>
          <h1>{{getUser.name}} - {{getUser.email}}</h1>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-btn @click="navigateTo('forgotpassword')" :color="config.primary" class="mt-5">
                Change Password
              </v-btn>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col>
            <h3 class="mb-3">WARNING: This will delete all your saved chips and other data stored with your user!</h3>
            <v-btn @click="deleteModal = true" :color="config.primary">
              Delete Account
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="deleteModal" width="450">
      <modal>
        <template v-slot:toolbar>
          <v-toolbar 
          v-bind:color="config.primary"
          dark
          flat
          >
            <v-row justify="center">
              <v-toolbar-title class="display-1 text-center">
                Are you sure?
              </v-toolbar-title>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:title>
          <v-card-text class="title text-center text-break">
            Do you really want to do delete your account?
            <br>
            <br>
            Deleting your account will remove all chips that you have made!
          </v-card-text>
        </template>
        <template v-slot:text>
          <div>

          </div>
        </template>
        <template v-slot:actions>
          <v-btn outlined class="ml-auto mb-1" :loading="deleteLoading" dark @click="deleteAccount()" :color="config.alert">
            Continue
            <v-icon right>mdi-alert-circle-outline</v-icon>
          </v-btn>
          <v-btn outlined class="ml-auto mr-auto mb-1" :loading="deleteLoading" dark @click="deleteModal = false" :color="config.confirm">
            Go Back
          </v-btn>
        </template>
      </modal>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config/config'
import { mapGetters } from 'vuex'
import AuthService from '@/services/AuthService'
import Modal from '@/components/Modal'

export default {
  name: 'settings',
  data () {
    return {
      settings: {},
      config,
      deleteLoading: false,
      deleteModal: false,
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  },
  methods: {
    async deleteAccount() {
      this.deleteLoading = true
      AuthService.deleteAccount({
        token: this.getUser.token
      }).then(response => {
        alert(response.data.message)
        this.deleteLoading = false
        this.navigateTo('/')
        location.reload()
      }).catch(err => {
        alert(err.response.data.message)
        this.deleteLoading = false
      })
    },
    navigateTo (route) {
      this.$router.push(route)
    },
    async checkLogin () {
      if (!this.loggedIn) {
        this.$router.push({name: 'login'})
      }
    }
  },
  mounted() {
    this.checkLogin()
  },
  components: {
    Modal
  }
}
</script>